import { useQuery } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";

export interface PlaceSuggestion {
  code: string;
  name: string | null;
  city: string | null;
  country: string | null;
  type: string | null;
}

/**
 * Query-based airport/city autocomplete, backed by Duffel's places API
 * (supplier-agnostic route — see backend InternationalFlightAggregatorController::places).
 * Unlike useIntlAirports (Travex, preload-all-then-filter-locally), this
 * queries the backend live per search term — call with a debounced value.
 */
function useIntlPlaceSuggestions(query: string) {
  const trimmed = query.trim();

  const { data, isLoading, isFetching, isError, error } = useQuery<
    APIResponse<{ places: PlaceSuggestion[] }>,
    APIError
  >(
    ["intl-place-suggestions", trimmed],
    () =>
      get(`${API_URL}/aviation/international/v2/places?query=${encodeURIComponent(trimmed)}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    { enabled: trimmed.length >= 2, keepPreviousData: true }
  );

  return {
    places: data?.data?.places ?? [],
    isLoadingPlaces: isLoading || isFetching,
    isPlacesError: isError,
    placesError: error,
  };
}

export default useIntlPlaceSuggestions;
